/**
 * Transactions API
 * Domain API via HTTP transport (apiTransport) to the backend /api RPC.
 */

import { BatchOperation, MaintenanceTicket, Payment } from '@repo/shared-types';
import { apiTransport as router } from './transport';
import { getContext } from './core';

export const transactionsApi = {
  batch: async (operations: BatchOperation[]) => {
    const context = getContext();
    return router.post<{ success: number; failed: number; results: unknown[] }>('/transactions/batch', operations, context);
  },
  /** Integer USD cents. Temporary wire name `costCents` (prefer `actualCostCents`). */
  completeTicket: async (ticketId: string, costCents: number, notes?: string) => {
    const context = getContext();
    return router.post<MaintenanceTicket>(
      `/maintenance/tickets/${ticketId}/complete`,
      { actualCostCents: costCents, costCents, notes },
      context,
    );
  },
  payRent: async (
    tenantId: string,
    propertyId: string,
    amount: number,
    method: string,
    paymentMethodId: string,
    allocations: { receivableId: string; amount: number }[]
  ) => {
    const context = getContext();
    return router.post<Payment>(
      '/accounting/payments/process',
      {
        tenantId,
        propertyId,
        amount,
        method,
        paymentMethodId,
        description: 'Online Rent Payment',
        allocations,
      },
      context
    );
  },
};

